import React, { Component } from 'react';
import ADILOGO from "../assets/img/brand/location.png";
import { Card ,Button,Col,CardHeader,Row ,Link, Form } from 'reactstrap';
import Masonry, {ResponsiveMasonry} from "react-responsive-masonry";
import Container from 'reactstrap/lib/Container';
import "./newstyle.css";
import Modal from 'reactstrap/lib/Modal';
import ModalHeader from 'reactstrap/lib/ModalHeader';
import ModalBody from 'reactstrap/lib/ModalBody';
import ModalFooter from 'reactstrap/lib/ModalFooter';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import Input from 'reactstrap/lib/Input';
import CardTitle from 'reactstrap/lib/CardTitle';
import CardBody from 'reactstrap/lib/CardBody';
import axios from 'axios';
import Swal from 'sweetalert2';
import { configuration } from '../appConfig';
import RequestLoader from "../spinner";

const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000
  });

ClassicEditor.defaultConfig = {
    toolbar: {
        items: [
            'heading',
            '|',
            'bold',
            'italic',
            'link',
            // 'bulletedList',
            // 'numberedList',
            'undo',
            'redo'
        ]
    },
    link: {
        // Automatically add target="_blank" and rel="noopener noreferrer" to all external links.
        addTargetToExternalLinks: true,

        // Let the users control the "download" attribute of each link.
        decorators: [
            {
                mode: 'manual',
                label: 'Downloadable',
                attributes: {
                    download: 'download'
                }
            }
        ]
    }    
};
const breakpointColumnsObj = {
    default: 4,
    1100: 3,
    700: 2,
    500: 1
  };
var items = [
    {id: 1, name: 'My First Item'},
    {id: 2, name: 'Another item'},
    {id: 3, name: 'Third Item'},
    {id: 4, name: 'Here is the Fourth'},
    {id: 5, name: 'High Five'}
  ];
  
  // Convert array to JSX items
  items = items.map(function(item)
   {
    return <div key={item.id}>{item.name}</div>
  });

// axios.defaults.headers.common['X-Auth-Token'] = localStorage.getItem('partnerId');
  
export class Notes extends Component {
    constructor(props){
        super(props);
        this.state = {
            modal : false,
            isCheckBoxMode: false,
            title : "",
            content : "",
            notesObj : [],
            notesData: [],
            checked : [],
            error :[],
            updateError : [],
            response : [],
            isClickedOnUpdate : false,
            singleNoteResponse : [],
            addedNotes : [],
            classifiedArr: [],
            // addMarkedDone : false,
            editMarkedDone : false,
            deleteModal : false,
            deleteNoteId : "",
            loading : false,
            selectedSingleNoteId : "",
            words: {},
            lang: "us",
        }
    }

    getAllStickyNotes = async() => {
        let partnerId=localStorage.getItem("partnerId");
        const url = configuration.getAllStickyNotes;
        // const url = "http://192.168.1.90/note/getAllStickyNotes.php";
        await axios.get(url+`?partnerId=${partnerId}`)
        .then((response) => {
            this.setState({
                response: response.data.data
            }, () => this.classify())
        })
        .catch((error) => {
            alert("Something went wrong!")
        });
    }

    componentDidMount() {
        if(!localStorage.getItem('partnerId')) {
            this.props.history.push("/login")      
        } else {
            this.getAllStickyNotes();
        }
        this.getLang()
    }
    getLang = () => {
        const base_url = window.location.origin;
        axios.get(`${base_url}/lang.json`).then((res) => {
          this.setState({ words: res.data, lang: localStorage.getItem("lang") });
        });
      };
      lang = (word) => {
        const { lang, words } = this.state;
        return words[word] ? words[word][lang] : word;
      };
      static getDerivedStateFromProps(nextProps, prevState) {
        //alert(nextProps.lang+"123")
        if (nextProps.lang !== prevState.lang) {
          return { lang: nextProps.lang };
        } else return null;
      }
    editModal = (index) => {
        this.setState({
            modal : false,
            isClickedOnUpdate : true,
            singleNoteResponse : []
        })
        let id = this.state.classifiedArr[index].uuid;
        const url = configuration.getSingleStickyNote
        axios.get(url+`?id=${id}`)
        .then((response) => {
            this.setState({
                singleNoteResponse : response.data.data
            })
        })
        .catch((error) => {
            alert("Something went wrong!")
        });
    }



    updateDirect = (index) => {
        let id = this.state.classifiedArr[index].uuid;
        this.setState({
            selectedSingleNoteId : id,
            loading : true
        })
        const url = configuration.getSingleStickyNote
        axios.get(url+`?id=${id}`)
        .then((response) => {
            this.setState({
                singleNoteResponse : response.data.data
            },() => this.apiCall())
        })
        .catch((error) => {
            alert("Something went wrong!")
        });
    }
    
    apiCall = () => {
        let payload;
        if(this.state.singleNoteResponse.isNoteWithCheckboxes) {
            if(!this.state.singleNoteResponse.isMarkedDone) {

                this.state.singleNoteResponse.note_checklists = this.state.singleNoteResponse.note_checklists.map((note,i) => {
                    return {...note,isMarkedDone : "1"}
                })

                this.setState({
                    singleNoteResponse : this.state.singleNoteResponse
                })
                
                payload = {
                    ...this.state.singleNoteResponse,
                    isMarkedDone : "1",        
                } 
            } else {
                this.state.singleNoteResponse.note_checklists = this.state.singleNoteResponse.note_checklists.map((note,i) => {
                    return {...note,isMarkedDone : "0"}
                })

                this.setState({
                    singleNoteResponse : this.state.singleNoteResponse
                })
                
                payload = {
                    ...this.state.singleNoteResponse,
                    isMarkedDone : "0",        
                }
            }

        } else {
            if(!this.state.singleNoteResponse.isMarkedDone) {
                payload = {
                    ...this.state.singleNoteResponse,
                    isMarkedDone : "1"
                }
            } else {
                payload = {
                    ...this.state.singleNoteResponse,
                    isMarkedDone : "0"
                }
            }
        }
        const url = configuration.updateStickyNote;
        axios.post(url,payload)
        .then((res)=> {
            this.setState({
                loading : false
            })
            Toast.fire({
                type: 'success',
                title: res.data.message
            })
            this.getAllStickyNotes()
        })
        .catch((err)=> {
            // alert("something went wrong")
            this.setState({
                loading : false
            })
            Toast.fire({
                type: 'error',
                title: err
            })
        })
    }
    
    handleEditMarkDone = () => {
        if(!this.state.singleNoteResponse.isNoteWithCheckboxes) {
            this.setState({
                singleNoteResponse : {...this.state.singleNoteResponse, isMarkedDone : !this.state.singleNoteResponse.isMarkedDone}
            })
        } else {
            if(this.state.singleNoteResponse.isMarkedDone) {
                this.state.singleNoteResponse.note_checklists = this.state.singleNoteResponse.note_checklists.map((note,i) => {
                    if(note.content) {
                        return {...note,isMarkedDone : "0"}
                    }
                })
                if(this.state.addedNotes && this.state.addedNotes.length > 0) {
                    this.state.addedNotes = this.state.addedNotes.map((note,i) => {
                        if(note && note.content.trim() !== "") {
                            return {...note,isMarkedDone : "0"}
                        }
                    })
                }
                this.setState({
                    singleNoteResponse : {...this.state.singleNoteResponse, isMarkedDone : false},
                    addedNotes : this.state.addedNotes && this.state.addedNotes[0] && this.state.addedNotes[0].content ? this.state.addedNotes : []
                })
            } else {
                this.state.singleNoteResponse.note_checklists = this.state.singleNoteResponse.note_checklists.map((note,i) => {
                    if(note.content) {
                        return {...note,isMarkedDone : "1"}
                    }
                })
                if(this.state.addedNotes && this.state.addedNotes.length > 0) {
                    this.state.addedNotes = this.state.addedNotes.map((note,i) => {
                        if(note && note.content.trim() !== "") {
                            return {...note,isMarkedDone : "1"}
                        }
                    })
                }
                this.setState({
                    singleNoteResponse : {...this.state.singleNoteResponse, isMarkedDone : true},
                    addedNotes : this.state.addedNotes && this.state.addedNotes[0] && this.state.addedNotes[0].content ? this.state.addedNotes : []
                })
            }

        }
    }
    toggle = () => {
        this.setState({
            modal : !this.state.modal,
            error :[],
            checked : [],
            notesObj : [],
            content : "",
            title : "",
            isCheckBoxMode : false,
            singleNoteResponse : []
        })
    }
    updateToggle = () => {
        this.setState({
            isClickedOnUpdate : !this.state.isClickedOnUpdate,
            updateError : [],
            addedNotes : [],
        })
    }
    //set input value received from ui in state
    handleChange = (e) => {
        this.setState({
            [e.target.name] : e.target.value,
        })
    }
    handleUpdate = (e) => {
        if(e.target.name === "title") {
            this.state.singleNoteResponse.title = e.target.value
            this.setState({
                singleNoteResponse : this.state.singleNoteResponse
            })
        } else if(e.target.name === "note") {
            this.state.singleNoteResponse.content = e.target.value
            this.setState({
                singleNoteResponse : this.state.singleNoteResponse
            })
        }
    }
    //set editor input value in state
    handleCkEditorState = (e,editor) => {
        const data = editor.getData();
        if(this.state.isClickedOnUpdate) {
            this.setState({
                singleNoteResponse : {...this.state.singleNoteResponse,content : data}
            }) 
        } else {
            this.setState({
                content : data
            })
        }
    }
    // Add notes
    addNotes = () => {
        let notes = {
            id : Math.random(),
            note : "",
            isChecked : false,
        }
        this.state.notesObj.push(notes)
        this.setState({
            notesObj : this.state.notesObj
        })
    }
    // update Notes
    updateAddNotes = () => {
        let notes = {
            orderNo: this.state.singleNoteResponse.note_checklists.length + this.state.addedNotes && this.state.addedNotes.length + 1,
            content : "",
            isMarkedDone : "0",
            is_active : true
        }
        // this.state.singleNoteResponse.note_checklists.push(notes)
        this.state.addedNotes.push(notes)
        this.setState({
            singleNoteResponse : this.state.singleNoteResponse,
            addedNotes : this.state.addedNotes
        })
    }
    // handle add more input value
    handleInput = (e,i) => {
        this.state.notesObj[i][e.target.name] = e.target.value
        this.setState({
            notesObj : this.state.notesObj
        })
    } 
    //update input value
    updateInput = (e,i,status) => {
        if(status === "new"){
            this.state.addedNotes[i].content = e.target.value
            this.setState({
                addedNotes : this.state.addedNotes
            })
        }else{
            this.state.singleNoteResponse.note_checklists[i].content = e.target.value
            this.setState({
                singleNoteResponse : this.state.singleNoteResponse
            })
        }
    }
    // check & uncheck functionality for notes with checkbox
    handleCheck = (i) => {
        if(!this.state.notesObj[i].note){
            alert("Please Enter notes.")
        } else {
            this.state.notesObj[i]["isChecked"] = !this.state.notesObj[i]["isChecked"]
            this.setState({
                notesObj : this.state.notesObj
            })
        }
    } 
    //update check & uncheck functionality for notes with checkbox
    updateHandleCheck = (i,status) => {
        if(status === "old"){
            if(!this.state.singleNoteResponse.note_checklists[i].content){
                alert("Please Enter notes.")
            } else {
                (this.state.singleNoteResponse.note_checklists[i]["isMarkedDone"] === "1") ? this.state.singleNoteResponse.note_checklists[i]["isMarkedDone"]= "0" : this.state.singleNoteResponse.note_checklists[i]["isMarkedDone"] = "1"
                this.setState({
                    // singleNoteResponse
                    singleNoteResponse : this.state.singleNoteResponse
                }) 
            }
        }
        if(status === "new"){
            if(!this.state.addedNotes[i].content){
                alert("Please Enter notes.")
            } else {
                (this.state.addedNotes[i]["isMarkedDone"] === "1") ? this.state.addedNotes[i]["isMarkedDone"]= "0" : this.state.addedNotes[i]["isMarkedDone"] = "1"
                this.setState({
                    // singleNoteResponse
                    addedNotes : this.state.addedNotes
                }) 
            }
        }
        
    }
    // delete notes
    handleDelete = (id,i) => {
        this.state.notesObj.filter((val)=> {
            if(val.id === id){
                this.state.notesObj.splice(i, 1)
            }
            this.setState({
                notesObj : this.state.notesObj
            })
        })
    }
    // delete note with checkbox at update time
    updateDelete =  (id,i,status) => {
        if(status === "new"){
            this.state.addedNotes.filter((val)=> {
                if(val.orderNo === id){
                    this.state.addedNotes.splice(i,1)
                    // this.state.updateError.splice(i,1)
                }
                this.setState({
                    addedNotes : this.state.addedNotes
                    // updateError : this.state.updateError
                })
            })
        }else{
            this.state.singleNoteResponse.note_checklists.filter((val)=> {
                if(val.orderNo === id){
                    this.state.singleNoteResponse.note_checklists[i].is_active = false
                }
                this.setState({
                    singleNoteResponse : this.state.singleNoteResponse,
                })
            })
        }
    }
    // add notes api integration and validation
    handleClick = () => {
        let error = [];
        if(!this.state.title.trim()){
            error.push("title")
        }
        if(!this.state.isCheckBoxMode && !this.state.content.trim()){
            error.push("content")
        }
        {this.state.isCheckBoxMode && this.state.notesObj.forEach((val,i) => {
            if(!this.state.notesObj[i].note.trim()){
               error.push(`note${i}`)
            }
            if (error.length > 0) {
                this.setState({
                    error: error,
                })
            } else {
                this.setState({
                    error: [],
                })
            }
        })}
        if (error.length > 0) {
            this.setState({
                error: error,
            })
        } else {
            this.setState({
                error: [],
            })
            let payLoad;
            if(this.state.isCheckBoxMode){
                let noteData = [];
                this.state.notesObj.map((val,i)=> {
                    let obj = {
                        content : val.note,
                        isMarkedDone : val.isChecked,
                        orderNo : i+1,
                        is_active : true
                    }
                    noteData.push(obj)
                })

                payLoad = {
                    partnerId: localStorage.getItem("partnerId"),
                    title: this.state.title,
                    isNoteWithCheckboxes : true,
                    note_checklists : noteData,
                }
                const url = configuration.createStickyNote
                // const url = "http://192.168.1.90/note/createStickyNote.php";
                axios.post(url, payLoad)
                .then((response) => {
                    Toast.fire({
                        type: 'success',
                        title: response.data.message
                    })
                    this.getAllStickyNotes()
                })
                .catch((error) => {
                    Toast.fire({
                        type: 'danger',
                        title: "Something went wrong"
                    })
                });
            }else{
                payLoad = {
                    partnerId: localStorage.getItem("partnerId"),
                    title: this.state.title,
                    content: this.state.content,
                    isNoteWithCheckboxes : false,
                }
                axios.post('http://driveandscan.de/api_v2/notes/createStickyNote.php', payLoad)
                .then((response) => {
                    Toast.fire({
                        type: 'success',
                        title: response.data.message
                    })
                    this.getAllStickyNotes()
                })
                .catch((error) => {
                    alert("something went wrong")
                });
            }
                this.state.notesData.push(payLoad)
                this.setState({
                    notesData : this.state.notesData,
                    modal : false
                })
        }
    }
    // update notes api integration and validation
    updateNotes = () => {
        let error = [];
        if(!this.state.singleNoteResponse.title.trim()){
            error.push("title")
        }
        if(!this.state.singleNoteResponse.isNoteWithCheckboxes && !this.state.singleNoteResponse.content.trim()){
            error.push("content")
        }
        {this.state.singleNoteResponse.isNoteWithCheckboxes && this.state.singleNoteResponse.note_checklists.forEach((val,i) => {
            if(!val.content.trim() && val.is_active === "1"){
               error.push(`note${i}`)
            }
            if (error.length > 0) {
                this.setState({
                    updateError: error,
                })
            } else {
                this.setState({
                    updateError: [],
                })
            }
        })}
        {this.state.addedNotes && this.state.addedNotes.forEach((val,i) => {
            if(!val.content.trim() && val.is_active === true){
               error.push(`newNote${i}`)
            }
            if (error.length > 0) {
                this.setState({
                    updateError: error,
                })
            } else {
                this.setState({
                    updateError: [],
                })
            }
        })}
        if (error.length > 0) {
            this.setState({
                updateError: error,
            })
        } else {
            this.setState({
                updateError: [],
            })
            let payLoad = {
                uuid : this.state.singleNoteResponse.uuid,
                partnerId: localStorage.getItem("partnerId"),
                title: this.state.singleNoteResponse.title,
                content : this.state.singleNoteResponse.isNoteWithCheckboxes ? "" :this.state.singleNoteResponse.content,
                isRead : true, 
                isMarkedDone : this.state.singleNoteResponse.isMarkedDone,
                isNoteWithCheckboxes : this.state.singleNoteResponse.isNoteWithCheckboxes,
                image: "",
                note_checklists : this.state.singleNoteResponse.isNoteWithCheckboxes ? this.state.singleNoteResponse.note_checklists : [],
                new_checklist_items : this.state.singleNoteResponse.isNoteWithCheckboxes ? this.state.addedNotes : [],
            }
            const url = configuration.updateStickyNote;
            axios.post(url,payLoad)
            .then((res)=> {
                    Toast.fire({
                        type: 'success',
                        title: res.data.message
                    })
                    this.setState({
                        addedNotes : [],
                        isClickedOnUpdate : false
                    })
                    this.getAllStickyNotes()
            })
            .catch((err)=> 
                // alert("something went wrong")
                Toast.fire({
                    type: 'error',
                    title: err
                })
            )
        }
    }
    // function to remove notes with checked checkbox 
    remove = (i,ele) => {
        this.state.checked.map((val,id)=>{
            if(val && val.id === ele.id){
                this.state.checked.splice(id,1)
            }
        })
    }
    // function to add notes with checked checkbox 
    add = (ele)=> {
        this.state.checked.push(ele)
        var myArray = this.state.checked
        var unique = myArray.filter((v, i, a) => a.indexOf(v) === i);
        this.state.checked = unique
    }
    // handle uncheck notes with checkbox while Add notes
    handleUncheck = (i,id) => {
        this.state.notesObj.map((val,idx) => {
            if(val.id === id ){
                this.state.notesObj[idx]["isChecked"] = !this.state.notesObj[idx]["isChecked"] 
                this.setState({
                    notesObj : this.state.notesObj
                })
            }
        })
    }
    // handle uncheck notes with checkbox while edit notes
    updateHandleUncheck = (i,id,status) => {
        if(status === 'new'){
            this.state.addedNotes.map((val,idx) => {
                if(val.orderNo === id ){
                    this.state.addedNotes[i]["isMarkedDone"]= "0" 
                    this.setState({
                        addedNotes : this.state.addedNotes
                    })
                }
            })
        }else{
            this.state.singleNoteResponse.note_checklists.map((val,idx) => {
                if(val.orderNo === id ){
                    this.state.singleNoteResponse.note_checklists[i]["isMarkedDone"]= "0" 
                    this.setState({
                        singleNoteResponse : this.state.singleNoteResponse
                    })
                }
            })
        }
    }
    // convert notes from checkbox mode to text mode and text mode to checkbox mode while edit notes
    change = (check) => {
        this.setState({
            updateError :[],
            // singleNoteResponse : {...this.state.singleNoteResponse, isMarkedDone : false}
        })
        if(this.state.singleNoteResponse.isNoteWithCheckboxes !== true){
            let str = this.state.singleNoteResponse.content;
            let isMarkedDone = this.state.singleNoteResponse.isMarkedDone
            var parser = new DOMParser();
            var parsedHtml = parser.parseFromString(str, "text/html");
            let pTags = parsedHtml.getElementsByTagName("p");
            let h2Tag = parsedHtml.getElementsByTagName("h2");
            let h3Tag = parsedHtml.getElementsByTagName("h3");
            let h4Tag = parsedHtml.getElementsByTagName("h4");
            let listTag = parsedHtml.getElementsByTagName("li");
            let FinalData = []
            Array.from(pTags).forEach(function(item){
            let allText = item.textContent;
            FinalData.push({isMarkedDone:  isMarkedDone ? "1" : "0", content: allText, is_active : "1",orderNo:FinalData.length+1})
            });
            Array.from(h2Tag).forEach(function(item){
            let allText = item.textContent;
            FinalData.push({isMarkedDone: isMarkedDone ? "1" : "0", content: allText, is_active : "1",orderNo:FinalData.length+1})
            });
            Array.from(h3Tag).forEach(function(item){
            let allText = item.textContent;
            FinalData.push({isMarkedDone: isMarkedDone ? "1" : "0", content: allText, is_active : "1",orderNo:FinalData.length+1})
            });
            Array.from(h4Tag).forEach(function(item){
            let allText = item.textContent;
            FinalData.push({isMarkedDone: isMarkedDone ? "1" : "0", content: allText, is_active : "1",orderNo:FinalData.length+1})
            });
            Array.from(listTag).forEach(function(item){
            let allText = item.textContent;
            FinalData.push({isMarkedDone: isMarkedDone ? "1" : "0", content: allText, is_active : "1",orderNo:FinalData.length+1})
            });
            let stateData = this.state.singleNoteResponse.note_checklists
            let allData = [...FinalData, ...stateData]
            const uniqObjs = [];
            const dupeObjs = [];
            allData.forEach(obj => [uniqObjs,dupeObjs][+(allData.map(obj => obj.content).filter(val => val === obj.content).length > 1)].push(obj));

            this.setState({
                singleNoteResponse : {...this.state.singleNoteResponse,isNoteWithCheckboxes : !check}
            })

            if(uniqObjs.length > 0) {
                this.setState({
                    addedNotes : uniqObjs,
                })
            }
        } else {
            const ckData  = 
            `${this.state.singleNoteResponse.note_checklists.map(note =>{return `<p>${note.content}</p>`} )}` + 
            `${this.state.addedNotes.map(note =>{return `<p>${note.content}</p>`})}`
            this.setState({
                singleNoteResponse : {...this.state.singleNoteResponse,isNoteWithCheckboxes : !check,content : ckData.replace(/[,]+/g,"").trim()},
            })
        }
        
    }
    // convert notes from checkbox mode to text mode and text mode to checkbox mode while add notes
    changeCreate = () => {
        this.setState({
            error : []
        });
        if(this.state.isCheckBoxMode !== true){
            let str = this.state.content;
            var parser = new DOMParser();
            var parsedHtml    = parser.parseFromString(str, "text/html");
            let pTags = parsedHtml.getElementsByTagName("p");
            let h2Tag = parsedHtml.getElementsByTagName("h2");
            let h3Tag = parsedHtml.getElementsByTagName("h3");
            let h4Tag = parsedHtml.getElementsByTagName("h4");
            let listTag = parsedHtml.getElementsByTagName("li");
            // let spanTag = parsedHtml.getElementsByTagName("span");
            let FinalData = []
            Array.from(pTags).forEach(function(item){
            let allText = item.textContent;
            FinalData.push({id:Math.random(),isChecked: false, note: allText})
            });
            Array.from(h2Tag).forEach(function(item){
            let allText = item.textContent;
            FinalData.push({id:Math.random(),isChecked: false, note: allText})
            });
            Array.from(h3Tag).forEach(function(item){
            let allText = item.textContent;
            FinalData.push({id:Math.random(),isChecked: false, note: allText})
            });
            Array.from(h4Tag).forEach(function(item){
            let allText = item.textContent;
            FinalData.push({id:Math.random(),isChecked: false, note: allText})
            });
            Array.from(listTag).forEach(function(item){
            let allText = item.textContent;
            FinalData.push({id:Math.random(),isChecked: false, note: allText})
            });
            // Array.from(spanTag).forEach(function(item){
            // let allText = item.textContent;
            // FinalData.push({id:Math.random(),isChecked: false, note: allText})
            // });
            this.setState({
                notesObj : FinalData,
                isCheckBoxMode : !this.state.isCheckBoxMode,
            })
        } else {
            const ckData  = 
                `${this.state.notesObj.map(note =>{return `<p>${note.note}</p>`} )}`
                // ckData.replace(/[, ]+/g, " ").trim()
                this.setState({
                content: ckData.replace(/[, ]+/g,"").trim(),
                isCheckBoxMode : !this.state.isCheckBoxMode,
            })
        }
    }
    // handleCardCheck = (order,idx,i) => {
    //     (this.state.response[i].notechecklist[idx]["isMarkedDone"] === "0")
    //     ? this.state.response[i].notechecklist[idx]["isMarkedDone"] = "1"
    //     :   this.state.response[i].notechecklist[idx]["isMarkedDone"] ="0"
    //     this.setState({
    //         response : this.state.response
    //     })
    // }
    // delete
    
    delete = () => {
        const url = configuration.deleteStickyNote;
        axios.delete(url+`?note_id=${this.state.deleteNoteId}`)
        .then((res)=> {
            this.setState({
                deleteModal : false,
                deleteNoteId : ""
            })
            Toast.fire({
                type: 'success',
                title: res.data.message
            })
            this.getAllStickyNotes()
        })
        .catch((err)=> 
            // alert("something went wrong")
            Toast.fire({
                type: 'error',
                title: "Something went wrong"
            })
        )
    }

    deleteModal = (uuid) => {
        this.setState({
            deleteNoteId : uuid,
            deleteModal : true
        })
    }

    classify = () => {
        let classifiedArr = [];
        this.state.response.map((note,i) => (
            (note.isMarkedDone===false) && (note.isRead===false)) && classifiedArr.push(note) 
        )
        classifiedArr = classifiedArr.reverse()
        this.state.response.map((note,i) => (
            (note.isMarkedDone===false) && (note.isRead===true)) && classifiedArr.push(note) 
        )
        this.state.response.map((note,i) => (
            (note.isMarkedDone===true) && (note.isRead===false)) && classifiedArr.push(note) 
        )
        this.state.response.map((note,i) => (
            (note.isMarkedDone===true) && (note.isRead===true)) && classifiedArr.push(note) 
        )
        this.setState({
            classifiedArr
        })
    }

    render() {
        const { modal,title,isCheckBoxMode,notesObj,checked, isClickedOnUpdate, singleNoteResponse,addedNotes} = this.state
        return (
        <>
            <div className="Container">
                <div className="pr-0 text-right ">
                    <CardHeader>
                        <Row className="p-0">
                            <Col lg-6></Col>
                            <Col lg-6 className="pr-0">
                                <Button type="button" className="serchqr-btn" onClick={() => this.toggle()}>
                                    {this.lang("Add New")}
                                </Button>
                            </Col>
                        </Row>
                    </CardHeader>
                </div>
                
                
                <Modal isOpen={modal}  scrollable={true} toggle={()=>this.toggle()} className="create_notes_modal" size='lg'>
                    {/* <ModalHeader className="align-item-center" toggle={()=>this.toggle()} closeButton>
                        <Row>
                            <div className="col">
                                <p className="">Create Notes</p>
                            </div>
                            <div className="col">
                                <Button className={this.state.isCheckBoxMode ? "btn btn-success check-box-modal-btn" : "btn check-box-modal-btn-uncheck" } onClick={()=>this.changeCreate()}
                                data-toggle="tooltip" data-placement="bottom" title={!this.state.isCheckBoxMode ? "Switch to Checkbox" : "Switch to Editor"} ><i className="fa fa-check" aria-hidden="true"></i></Button>
                            </div>
                        </Row>
                    </ModalHeader> */}
                    <div className='modal_header container'>
                        <div className='row align-items-center'>
                            <div className='col-6 p-0'>
                            <p className="">{this.lang("Create Notes")}</p>
                            </div>
                            <div className='col-6 p-0'>
                                <div className='row text-right align-items-center justify-content-end'>
                                    <div className='col-3'>
                                    {/* <Button className={this.state.isCheckBoxMode ? "btn btn-success check-box-modal-btn" : "btn check-box-modal-btn-uncheck" } onClick={()=>this.changeCreate()} data-toggle="tooltip" data-placement="bottom" title={!this.state.isCheckBoxMode ? this.lang("Switch to Checkbox") : this.lang("Switch to Editor")} ><i className="fa fa-check" aria-hidden="true"></i></Button> */}
                                    {/* <Button className={this.state.isCheckBoxMode ? "btn btn-success check-box-modal-btn" : "btn check-box-modal-btn-uncheck" } onClick={()=>this.changeCreate()} data-toggle="tooltip" data-placement="bottom" title={!this.state.isCheckBoxMode ? "Switch to Checkbox" : "Switch to Editor"} ><i className="fa fa-check" aria-hidden="true"></i></Button> */}
                                        <input
                                            className="react-switch-checkbox"
                                            id={`react-switch-new`}
                                            type="checkbox"
                                            onClick={()=>this.changeCreate()} 
                                        />
                                        <label
                                            style={{background :  this.state.isCheckBoxMode ? "#00C07A" : "#FF0000" }}
                                            className="react-switch-label"
                                            htmlFor={`react-switch-new`}
                                            data-toggle="tooltip"
                                            data-placement="bottom"
                                            title={!this.state.isCheckBoxMode ? this.lang("Switch to Checkbox") : this.lang("Switch to Editor")}
                                        >
                                            <span className={`react-switch-button`} />
                                            {!this.state.isCheckBoxMode ? 
                                                <span className="on" style={{right : '3px'}}><i className="fa fa-check-square-o" aria-hidden="true"></i></span>
                                            :
                                                <span className="off" style={{right : '28px'}}><i className="fa fa-dot-circle-o" aria-hidden="true"></i></span>
                                            }
                                        </label>
                                    </div>
                                    <div className='col-2'>
                                        <Button variant="secondary" size="sm" onClick={()=> this.setState({modal:!this.state.modal})}><i className="fa fa-times" aria-hidden="true"></i> </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <ModalBody>
                        <div className="checkbox-content">
                            <div className="text-editor text-left container">
                            {/* <h5>Title</h5> */}
                            <div className="mb-2">
                            <Input
                                placeholder="Title"
                                className="input-text title-input border-bottom"
                                type="text"
                                name="title"
                                value={title}
                                onChange={(e) => this.handleChange(e)}
                            />
                            {this.state.error.includes("title") && (
                                <span className="text-danger">{this.lang("Title is Required")}</span>
                            )}
                            </div>
                                {!this.state.isCheckBoxMode &&
                                    <CKEditor  
                                        // id={}
                                        placeholder="Take a Notes"
                                        name="note"
                                        editor={ClassicEditor}
                                        onInit= {editor => {
                                        // this inializes our application
                                        }}
                                        onChange={(e,editor)=>this.handleCkEditorState(e,editor)}
                                        data={this.state.content}
                                    />
                                }   
                                {this.state.error.includes(`content`) && (<span className="text-danger">Please Enter Notes</span>)}
                            </div>        
                            
                            <div className="check-box-content mt-3">
                                {this.state.isCheckBoxMode &&
                                        <ul>
                                            {notesObj.map((notes,i)=>{
                                                if (!notes.isChecked) {
                                                    return <>
                                                            {this.remove(i, notes)}
                                                            <li className="mb-2">
                                                                <label className="row align-items-center p-0">
                                                                    <div className="col-1">
                                                                        <input 
                                                                        type='checkbox' 
                                                                        name="color"
                                                                        checked={notes.isChecked}
                                                                        onClick={() => this.handleCheck(i)}/>
                                                                    </div>
                                                                    <div className="col-10">
                                                                        <Input className="input-text border-bottom"  placeholder="Take a Notes" type="text"  name="note" value={notes.note}  onChange={(e) => this.handleInput(e, i)} style={{textDecoration: notes.isChecked && "line-through"}}/>
                                                                        {this.state.error.includes(`note${i}`) && (
                                                                            <span className="text-danger">{this.lang("Please Enter Notes")}</span>
                                                                        )}
                                                                    </div>
                                                                    <div className="col-1 p-0">
                                                                        <Button className="btn btn-danger" onClick={()=> this.handleDelete(notes.id, i)} data-toggle="tooltip" data-placement="bottom" title="Delete"><i className="fa fa-trash-o" aria-hidden="true"></i></Button>
                                                                    </div>
                                                                </label>
                                                            </li>
                                                        </>
                                                }else{
                                                    this.add(notes);
                                                }   
                                            })}
                                            {/* <li>
                                                <label className="row align-items-center p-0">
                                                    <div className="col-1">
                                                        <input type='checkbox' name="color"/>
                                                    </div>
                                                    <div className="col-10">
                                                        <Input className="input-text"  placeholder="Text" type="text"/>
                                                    </div>
                                                    <div className="col-1 p-0">
                                                        <Button className="btn btn-danger"><i className="fa fa-trash-o" aria-hidden="true"></i></Button>
                                                    </div>
                                                </label>
                                            </li> */}
                                            {isCheckBoxMode && checked.length > 0 && (
                                            <>
                                            <hr />
                                            <label>
                                                <h5>
                                                <b>{this.lang("Completed")}</b>
                                                </h5>
                                            </label>
                                            <hr />
                                            </>)}
                                            {isCheckBoxMode && this.state.checked.map((notes, i) => (
                                                <li>
                                                    <label className="row align-items-center p-0">
                                                        <div className="col-1">
                                                            <input type='checkbox' name="color" onClick={() => this.handleUncheck(i, notes.id)} checked={true}/>
                                                        </div>
                                                        <div className="col-11">
                                                            {/* <Input style={{ textDecoration: notes.isChecked && "line-through" }} className="input-text" value={notes.note} type="text"/> */}
                                                            <p style={{textDecoration: notes.isChecked && "line-through" }}>{notes.note}</p>
                                                        </div>
                                                    </label>
                                                </li>                                
                                            ))}
                                            
                                        </ul>
                                    }
                            </div>
                        </div>
                    </ModalBody>

                    <ModalFooter >
                        <div className="col-12 text-right p-0">  
                            {isCheckBoxMode && <Button className="btn btn-success modal-save mx-3" onClick={()=>this.addNotes()} data-toggle="tooltip" data-placement="bottom" title="Add Notes">{this.lang("Add Tasks")}</Button>}
                            <Button className="btn btn-danger modal-save mx-3" onClick={()=>this.handleClick()}>{this.lang("Save")}</Button>
                        </div>
                    </ModalFooter>
                </Modal> 
                
                <Modal isOpen={isClickedOnUpdate}  scrollable={true} toggle={()=>this.updateToggle()} className="create_notes_modal" size='lg'>
                    {/* <ModalHeader className="align-item-center" toggle={()=>this.updateToggle()}>
                        <Row className="row pl-0">
                            <div className="col-6 pl-0">
                                <h5 className="modal-title">Edit Notes</h5>
                            </div>
                            <div className="col-6">
                                <Button className={singleNoteResponse.isNoteWithCheckboxes ? "btn btn-success check-box-modal-btn" : "btn check-box-modal-btn-uncheck" } 
                                // onClick={()=>this.setState({
                                //     [this.state.singleNoteResponse.isNoteWithCheckboxes] : !singleNoteResponse.isNoteWithCheckboxes,
                                //     error : []
                                // })}
                                onClick={()=>this.change(singleNoteResponse.isNoteWithCheckboxes)}
                                 data-toggle="tooltip" data-placement="bottom" title={!this.state.isCheckBoxMode ? "Switch to Checkbox" : "Switch to Editor"} ><i className="fa fa-check" aria-hidden="true"></i></Button>
                            </div>
                        </Row>
                    </ModalHeader> */}

                    <div className='modal_header container'>
                        <div className='row align-items-center'>
                            <div className='col-8 p-0'>
                            <p className="">{this.lang("Edit Notes")}</p>
                            </div>
                            <div className='col-4 p-0'>
                                <div className='row text-right align-items-center justify-content-end'>
                                    <div className='col-4'>
                                    {/* <Button className={singleNoteResponse.isNoteWithCheckboxes ? "btn btn-success check-box-modal-btn" : "btn check-box-modal-btn-uncheck" } 
                                    // onClick={()=>this.setState({
                                    //     [this.state.singleNoteResponse.isNoteWithCheckboxes] : !singleNoteResponse.isNoteWithCheckboxes,
                                    //     error : []
                                    // })}
                                    onClick={()=>this.change(singleNoteResponse.isNoteWithCheckboxes)}
                                    data-toggle="tooltip" data-placement="bottom" title={!this.state.isCheckBoxMode ? this.lang("Switch to Checkbox") : this.lang("Switch to Editor")} ><i className="fa fa-check" aria-hidden="true"></i></Button> */}
                                    <input
                                            className="react-switch-checkbox"
                                            id={`react-switch-new`}
                                            type="checkbox"
                                            onClick={()=>this.change(singleNoteResponse.isNoteWithCheckboxes)}
                                        />
                                        <label
                                            style={{background :  singleNoteResponse.isNoteWithCheckboxes ? "#00C07A" : "#FF0000" }}
                                            className="react-switch-label"
                                            htmlFor={`react-switch-new`}
                                            data-toggle="tooltip"
                                            data-placement="bottom"
                                            title={!singleNoteResponse.isNoteWithCheckboxes ? this.lang("Switch to Checkbox") : this.lang("Switch to Editor")}
                                        >
                                            <span className={`react-switch-button`} />
                                            {!singleNoteResponse.isNoteWithCheckboxes ? 
                                                <span className="on" style={{right : '3px'}}><i className="fa fa-check-square-o" aria-hidden="true"></i></span>
                                            :
                                                <span className="off" style={{right : '28px'}}><i className="fa fa-dot-circle-o" aria-hidden="true"></i></span>
                                            }
                                        </label>
                                    </div>
                                    <div>
                                        <input type="checkbox" className='btn btn-success Add-btn mx-1 edit_btn' checked={singleNoteResponse.isMarkedDone} onClick={()=>this.handleEditMarkDone()}/>
                                    </div>
                                    <div className='col-1'>
                                        <Button variant="secondary" size="sm" onClick={()=>this.setState({isClickedOnUpdate : !this.state.isClickedOnUpdate, addedNotes : []})}><i className="fa fa-times" aria-hidden="true"></i> </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <ModalBody>
                        <div className="checkbox-content">
                            <div className="text-editor text-left container">
                            {/* <h5>Title</h5> */}
                            <div className="mb-2">
                            <Input
                                placeholder="Title"
                                className="input-text title-input border-bottom"
                                type="text"
                                name="title"
                                value={this.state.singleNoteResponse.title}
                                onChange={(e) => this.handleUpdate(e)}
                            />
                            {this.state.updateError.includes("title") && (
                                <span className="text-danger">Title is Required</span>
                            )}
                            </div>
                                {!this.state.singleNoteResponse.isNoteWithCheckboxes &&
                                    <CKEditor  
                                        // id={}
                                        placeholder="Take a Notes"
                                        name="note"
                                        editor={ClassicEditor}
                                        data={this.state.singleNoteResponse.content}
                                        onInit= {editor => {
                                        // this inializes our application
                                        }}
                                        onChange={(e,editor)=>this.handleCkEditorState(e,editor)}
                                    />
                                }   
                                {this.state.updateError.includes(`content`) && (<span className="text-danger">Please Enter Notes</span>)}
                            </div>        
                            
                            <div className="check-box-content mt-3">
                                {this.state.singleNoteResponse.isNoteWithCheckboxes &&
                                        <ul>
                                            {this.state.singleNoteResponse.note_checklists.map((notes,i)=>{
                                                if (notes.isMarkedDone === "0" && notes.is_active !== false) {
                                                    return <>
                                                            {this.remove(i, notes)}
                                                            <li className="mb-2">
                                                                <label className="row align-items-center p-0">
                                                                    <div className="col-1">
                                                                        <input 
                                                                        type='checkbox' 
                                                                        name="color"
                                                                        checked={notes.isMarkedDone === "1"}
                                                                        onClick={() => this.updateHandleCheck(i,"old")}/>
                                                                    </div>
                                                                    <div className="col-10">
                                                                        <Input className="input-text border-bottom"  placeholder="Take a Notes" type="text"  name="note" value={notes.content}  onChange={(e) => this.updateInput(e, i)} style={{textDecoration: notes.isChecked && "line-through"}}/>
                                                                        {this.state.updateError.includes(`note${i}`) && (
                                                                            <span className="text-danger">Please Enter Notes</span>
                                                                        )}
                                                                    </div>
                                                                    <div className="col-1 p-0">
                                                                        <Button className="btn btn-danger" onClick={()=> this.updateDelete(notes.orderNo, i)} data-toggle="tooltip" data-placement="bottom" title="Delete"><i className="fa fa-trash-o" aria-hidden="true"></i></Button>
                                                                    </div>
                                                                </label>
                                                            </li>
                                                        </>
                                                }else{
                                                    this.add(notes);
                                                }   
                                            })}
                                            {addedNotes && addedNotes.map((notes,i)=> {
                                                 if (notes && notes.isMarkedDone === "0" && notes.is_active !== false) {
                                                    return <>
                                                            {this.remove(i, notes)}
                                                            <li className="mb-2">
                                                                <label className="row align-items-center p-0">
                                                                    <div className="col-1">
                                                                        <input 
                                                                        type='checkbox' 
                                                                        name="color"
                                                                        checked={notes.isMarkedDone === "1"}
                                                                        onClick={() => this.updateHandleCheck(i,"new")}/>
                                                                    </div>
                                                                    <div className="col-10">
                                                                        <Input className="input-text border-bottom"  placeholder="Take a Notes" type="text"  name="note" value={notes.content}  onChange={(e) => this.updateInput(e, i,'new')} style={{textDecoration: notes.isChecked && "line-through"}}/>
                                                                        {this.state.updateError.includes(`newNote${i}`) && (
                                                                            <span className="text-danger">Please Enter Notes</span>
                                                                        )}
                                                                    </div>
                                                                    <div className="col-1 p-0">
                                                                        <Button className="btn btn-danger" onClick={()=> this.updateDelete(notes.orderNo, i,"new")} data-toggle="tooltip" data-placement="bottom" title="Delete"><i className="fa fa-trash-o" aria-hidden="true"></i></Button>
                                                                    </div>
                                                                </label>
                                                            </li>
                                                        </>
                                                }else{
                                                    this.add(notes);
                                                }   
                                            })}
                                            {/* <li>
                                                <label className="row align-items-center p-0">
                                                    <div className="col-1">
                                                        <input type='checkbox' name="color"/>
                                                    </div>
                                                    <div className="col-10">
                                                        <Input className="input-text"  placeholder="Text" type="text"/>
                                                    </div>
                                                    <div className="col-1 p-0">
                                                        <Button className="btn btn-danger"><i className="fa fa-trash-o" aria-hidden="true"></i></Button>
                                                    </div>
                                                </label>
                                            </li> */}
                                            {checked.length > 0 && 
                                            <>
                                                <hr />
                                                <label>
                                                    <h5>
                                                    <b>{this.lang("Completed")}</b>
                                                    </h5>
                                                </label>
                                                <hr />   
                                            </>
                                            }   
                                            {this.state.singleNoteResponse.isNoteWithCheckboxes && 
                                                this.state.singleNoteResponse.note_checklists.map((val,idx) => (
                                                val.isMarkedDone === "1" &&
                                                <>                                         
                                                <li>
                                                    <label className="row align-items-center p-0">
                                                        <div className="col-1">
                                                            <input type='checkbox' name="color" checked={true}
                                                            onClick={() => this.updateHandleUncheck(idx, val.orderNo)}/>
                                                        </div>
                                                        <div className="col-11">
                                                            {/* <Input style={{ textDecoration: notes.isChecked && "line-through" }} className="input-text" value={notes.note} type="text"/> */}
                                                            <p style={{textDecoration: val.isMarkedDone === "1" && "line-through" }}>{val.content}</p>
                                                        </div>
                                                    </label>
                                                </li>                                
                                            </>))}
                                            {this.state.addedNotes && 
                                                this.state.addedNotes.map((val,idx) => (
                                                val && val.isMarkedDone === "1" &&
                                                <>                                         
                                                <li>
                                                    <label className="row align-items-center p-0">
                                                        <div className="col-1">
                                                            <input type='checkbox' name="color" checked={true}
                                                            onClick={() => this.updateHandleUncheck(idx, val.orderNo,'new')}/>
                                                        </div>
                                                        <div className="col-11">
                                                            {/* <Input style={{ textDecoration: notes.isChecked && "line-through" }} className="input-text" value={notes.note} type="text"/> */}
                                                            <p style={{textDecoration: val.isMarkedDone === "1" && "line-through" }}>{val.content}</p>
                                                        </div>
                                                    </label>
                                                </li>                                
                                            </>))}
                                        </ul>
                                    }
                            </div>
                        </div>
                    </ModalBody>

                    <ModalFooter >
                        <div className="col-12 text-right p-0">  
                            {singleNoteResponse.isNoteWithCheckboxes && 
                            <Button className="btn btn-success modal-save mx-3" 
                            onClick={()=>this.updateAddNotes()} 
                            data-toggle="tooltip" 
                            data-placement="bottom" 
                            title="Add Notes">
                            {this.lang("Add Tasks")}
                            </Button>}
                            <Button className="btn btn-danger modal-save mx-3" onClick={()=>this.updateNotes()}>{this.lang("Update")}</Button>
                        </div>
                    </ModalFooter>
                </Modal>

                <Modal size="md" isOpen={this.state.deleteModal}  className='modal1 pass_fail_modal'>
                    <ModalHeader>
                      <strong>{this.lang("Delete Notes")}</strong>
                    </ModalHeader>
                    <ModalBody>
                      <p>{this.lang("Are you sure you want to delete this note?")}</p>
                    </ModalBody>
                    <ModalFooter>
                      <Button color="secondary" className="btn btn-danger modal-save mx-3" onClick={()=>this.delete()}>{this.lang("Delete")}</Button>
                      <Button color="secondary" onClick={()=>this.setState({deleteModal : false, deleteNoteId : ""})}>{this.lang("Cancel")}</Button>
                    </ModalFooter>
                </Modal>
                            <ResponsiveMasonry columnsCountBreakPoints={{ 350: 1, 750: 2, 900: 3, 1080:4, 1280:4}}>
                            <Masonry
                            breakpointCols={breakpointColumnsObj}
                            className="my-masonry-grid "
                            columnClassName="my-masonry-grid_column">
                        {
                            this.state.classifiedArr.length > 0 && 
                            this.state.classifiedArr.map((note,i) => 
                            (!note.isNoteWithCheckboxes) ?
                            <div>
                                <Card className="notes-card">
                                    <CardTitle>
                                        <div className="card_heading">
                                            <Row className="align-items-center card-title-row p-0">
                                                <Col lg={5} md={5} sm={5} xs={6} className="pl-0">
                                                <h5>{note.title}</h5>
                                                </Col>
                                                <Col lg={7} md={7} sm={7} xs={6} className="text-right">
                                                    <>
                                                        <div className='d-flex justify-content-end align-items-center'>
                                                        {
                                                    this.state.loading && this.state.selectedSingleNoteId === note.uuid ?
                                                    <RequestLoader className= "mx-1 card_loader mt-1" size="30px"/>
                                                    :
                                                    <input className= " mx-1 mark_check mt-1" type="checkbox" checked={note.isMarkedDone} onClick={()=>this.updateDirect(i)}/>
                                                    }
                                                    <Button className= "btn btn-success Add-btn mx-1 edit_btn mt-1" onClick={() => this.editModal(i)}>
                                                        <i className="fa fa-pencil-square-o" aria-hidden="true"></i>
                                                    </Button>
                                                    <Button className= "btn btn-danger Add-btn mx-1 del_btn mt-1" onClick={() => this.deleteModal(note.uuid, i)}>
                                                        <i className="fa fa-trash-o" aria-hidden="true"></i>
                                                    </Button>
                                                        </div>
                                                    </>
                                                    
                                                </Col>
                                            </Row>
                                            </div>
                                    </CardTitle>
                                    <CardBody className="p-0">
                                        <div className="card_content">
                                            <div 
                                            className="card-body-text ellipsis-class" 
                                            style={{WebkitBoxOrient:"vertical"}} 
                                            dangerouslySetInnerHTML={{__html :  note.content}}> 
                                            </div>
                                        </div>
                                    </CardBody>
                                </Card>
                            </div>
                                :
                            <div>
                                <Card className="notes-card">
                                    <CardTitle>
                                    <div className="card_heading">
                                        <Row className="align-items-center card-title-row p-0">
                                            <Col lg={5} md={5} sm={5} xs={6} className="pl-0">
                                            <h5>{note.title}</h5>
                                            </Col>
                                            <Col lg={7} md={7} sm={7} xs={6} className="text-right">
                                                <>
                                                    <div className='d-flex justify-content-end align-items-center'>
                                                    {
                                                this.state.loading && this.state.selectedSingleNoteId === note.uuid ? 
                                                <RequestLoader className= "mx-1 mt-1" size="30px"/>
                                                :
                                                <input className= "mark_check mx-1 mt-1" type="checkbox" checked={note.isMarkedDone} onClick={()=>this.updateDirect(i)}/>
                                                }
                                                <Button className= "btn btn-success mx-1 Add-btn edit_btn mt-1" onClick={() => this.editModal(i)}>
                                                    <i className="fa fa-pencil-square-o" aria-hidden="true"></i>
                                                </Button>
                                                <Button className= "btn btn-danger Add-btn mx-1 del_btn mt-1" onClick={() => this.deleteModal(note.uuid, i)}>
                                                    <i className="fa fa-trash-o" aria-hidden="true"></i>
                                                </Button>
                                                    </div>
                                                </>
                                            </Col>
                                        </Row>
                                        </div>
                                    </CardTitle>
                                    <CardBody className="p-0">
                                        <div className="card_content">
                                            {
                                                note.notechecklist.map((checkboxNote,index) => (
                                                    <div style={{margin:"5px"}}>
                                                        {
                                                            index < 7 &&
                                                            <>
                                                            <input type="checkbox" id={index} checked={checkboxNote.isMarkedDone === "1"} />
                                                            <span style={{marginLeft:"5px", textDecoration: checkboxNote.isMarkedDone === "1" && "line-through"}}>
                                                                    {checkboxNote.content}
                                                            </span>
                                                            </> 
                                                        }
                                                        {
                                                            index === 7 && 
                                                            <>
                                                            <input type="checkbox" id={index} checked={checkboxNote.isMarkedDone === "1"} />
                                                            <span style={{marginLeft:"5px", textDecoration: checkboxNote.isMarkedDone === "1" && "line-through"}}>
                                                                {checkboxNote.content} ...
                                                            </span>
                                                            </>
                                                        }
                                                    </div>
                                                ))
                                            }
                                        </div>
                                    </CardBody>
                                </Card>
                            </div>
                            )
                        }
                    </Masonry>
                    </ResponsiveMasonry>
           </div>
        </>
    )
  }
}

export default Notes

